import React, { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, RootStateOrAny } from 'react-redux'
import { useDebouncedCallback } from 'use-debounce'
import { getUserId } from 'Redux/selectors/auth'
import { CampaignPlatformTypeEnum, ReviewDetails } from 'Types/index'
import { Desktop } from 'Shared/components/Responsive'
import Alert from 'Shared/components/Alert'

import { SkipReviewProps } from './props'
import {
  SkipReviewWrapper,
  SkipReviewHeader,
  SkipReviewText,
  AlertText,
  AlertTitle,
  ButtonsContainer,
  Button,
  ButtonSimple,
} from './styles'

export const SkipReview: FunctionComponent<SkipReviewProps> = ({
  toggle,
  handleSkipReview,
}) => {
  const { t } = useTranslation()
  const userId = useSelector(getUserId)
  const reviewDetails: ReviewDetails = useSelector(
    (state: RootStateOrAny) => state.reviews.reviewDetails
  )

  const [isSkipDisabled, setIsSkipDisabled] = useState(false)

  const [debounceSkipReview] = useDebouncedCallback(() => {
    setIsSkipDisabled(true)
    handleSkipReview(null)
  }, 1000)

  return (
    <div>
      <SkipReviewWrapper>
        <Desktop>
          <SkipReviewHeader>{t('reviewsPage.skipReview')}</SkipReviewHeader>
        </Desktop>
        <SkipReviewText>{t('reviewsPage.ifThisTrack')}</SkipReviewText>
        <Alert color="success" icon unclosable rowDirection noGap>
          <AlertText>
            <AlertTitle>
              {t('reviewsPage.whenYouAreSkippingReviewYouWillEarnExtraScore')}
            </AlertTitle>
          </AlertText>
        </Alert>
        <ButtonsContainer>
          <ButtonSimple onClick={toggle}>
            {t('reviewsPage.cancel')}
          </ButtonSimple>
          <Button disabled={isSkipDisabled} onClick={debounceSkipReview}>
            {t('reviewsPage.confirm')}
          </Button>
        </ButtonsContainer>
      </SkipReviewWrapper>
    </div>
  )
}
